import { render, staticRenderFns } from "./pc-items.vue?vue&type=template&id=7204a081"
import script from "./pc-items.vue?vue&type=script&lang=js"
export * from "./pc-items.vue?vue&type=script&lang=js"
import style0 from "./pc-items.vue?vue&type=style&index=0&id=7204a081&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports